import React from 'react';
import { useForm } from 'react-final-form';

import { InputsRow } from '@interlayer/js/app/components/common/Fields/Input/components/InputsRow';
import { ZipField } from '@interlayer/js/app/components/main/Registration/components/fields/ZipField';
import { I18n } from '@interlayer/js/components/common/I18n';

import { useTranslations } from '@core/js/hooks/i18n';
import { clsb } from '@core/js/utils/classNames.util';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TAddressManuallyFieldsProps } from './types';

import style from './AddressManuallyFields.scss';

export const AddressManuallyFields: React.FC<TAddressManuallyFieldsProps> = ({
    classNames = {},
    isShowLinkAuto,
    isSeparateRows,
    className,
    handlerSwitchManually
}) => {
    const form = useForm();
    const { config: { showSuccessTickIcons } } = useRegistrationSelector();
    const t = useTranslations('playtech.mobile.system.registration.');
    const buildCls = clsb([style, classNames]);

    const { errors } = form.getState();

    const inputsAddress = [
        {
            name: VALIDATION_FIELDS.house,
            isShowValidationIcon: showSuccessTickIcons,
            placeholder: t('label.houseno')
        },
        {
            name: VALIDATION_FIELDS.street,
            isShowValidationIcon: showSuccessTickIcons,
            placeholder: t('label.street')
        }
    ];

    const inputsRegion = [
        {
            name: VALIDATION_FIELDS.state,
            isShowValidIcon: !errors?.zip,
            isShowValidationIcon: showSuccessTickIcons,
            placeholder: t('label.county')
        },
        {
            name: VALIDATION_FIELDS.city,
            isShowValidationIcon: showSuccessTickIcons,
            placeholder: t('label.town')
        }
    ];

    return (
        <div
            className={clsx(style.container, className)}
            data-testid="AddressManuallyFields__container"
        >
            <InputsRow
                options={inputsAddress}
                isSeparateRows={isSeparateRows}
            />

            <InputsRow
                options={inputsRegion}
                isSeparateRows={isSeparateRows}
            />

            <ZipField />

            {isShowLinkAuto && (
                <div className={buildCls(['linkAddressWrap'])}>
                    <div className={style.linkAddress} onClick={() => handlerSwitchManually(false)}>
                        <I18n t={t} tKey="findAutomaticallyAddress" />
                    </div>
                </div>
            )}
        </div>
    );
};
